"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.senseHistory = void 0;
/* eslint-disable no-restricted-globals */
const Logger_1 = __importDefault(require("../Logger"));
function print(...args) {
    Logger_1.default.debug("[HistorySensor]", ...args);
}
/**
 * Attaches the event listener for popstate
 * @param onSensed callback when "popstate" event is detected
 * @returns Function to stop the sensing
 */
function sensePopState(onSensed) {
    const onPopState = () => {
        print("state change observed");
        onSensed();
    };
    // Detects history.go, history.back, history.forward
    window.addEventListener("popstate", onPopState);
    print("State change observation started");
    return () => {
        print("State change observation stopped");
        window.removeEventListener("popstate", onPopState);
    };
}
/**
 * Attaches a spy to detect calls to History API
 * @param onSensed callback when the method is invoked
 * @param methods method names to spy on
 * @returns Function to stop the spy
 */
function senseHistoryAPI(onSensed, ...methods) {
    let disabled = false;
    const sensorList = methods
        .map((method) => [method, history[method]])
        .map(([method, original]) => [
        method,
        (...args) => {
            original.apply(history, args);
            if (disabled) {
                return;
            }
            print(`${method} observed`);
            onSensed();
        },
    ]);
    Object.assign(history, Object.fromEntries(sensorList));
    print("history observation started");
    return () => {
        print("history observation stopped");
        disabled = true;
    };
}
/**
 * Detects possible changes in the history state by:
 * Listening for the "popstate" event, typically emitted by history.go, history.forward, history.back
 * Listens to history API invocation ("pushState", "replaceState"), typically used by application for browser routing
 * @param onSensed callback when method is invoked
 * @returns Function to stop the detection callback
 */
function senseHistory(onSensed) {
    const stopEventListener = sensePopState(onSensed);
    const stopSpy = senseHistoryAPI(onSensed, "pushState", "replaceState");
    return () => {
        stopEventListener();
        stopSpy();
    };
}
exports.senseHistory = senseHistory;
